import { format } from 'date-fns'

const determineSubtitle = (article) => {
  const subtitleMap = {
    Event: `${format(
      new Date(article.startDate),
      'EE dd MMM, yyyy'
    )} • ${format(new Date(article.startDate), 'HH:mm')} • ${article.address}`,
    Interview: article.subAttribution
  }

  return subtitleMap[article.contentType] || ''
}

export default determineSubtitle
